export const productOptions = [
  {
    value: 'zimbra',
    label: 'Zimbra Email Suite',
    services: [
      { value: 'implementation', label: 'Implementation & Setup' },
      { value: 'migration', label: 'Migration Services' },
      { value: 'hosting', label: 'Hosted Zimbra' },
      { value: 'support', label: 'Maintenance & Support' }
    ]
  },
  {
    value: 'lemonldap',
    label: 'LemonLDAP::NG',
    services: [
      { value: 'implementation', label: 'Implementation' },
      { value: 'integration', label: 'Integration Services' },
      { value: 'hosting', label: 'Cloud SSO' },
      { value: 'support', label: 'Support & Maintenance' }
    ]
  },
  {
    value: 'nextcloud',
    label: 'Nextcloud Enterprise',
    services: [
      { value: 'implementation', label: 'Implementation' },
      { value: 'migration', label: 'Data Migration' },
      { value: 'hosting', label: 'Cloud Hosting' },
      { value: 'support', label: 'Support Services' }
    ]
  },
  {
    value: 'openldap',
    label: 'OpenLDAP Identity',
    services: [
      { value: 'implementation', label: 'Implementation' },
      { value: 'integration', label: 'System Integration' },
      { value: 'migration', label: 'Directory Migration' },
      { value: 'support', label: 'Support & Maintenance' }
    ]
  }
];

export const supportTiers = [
  { value: 'basic', label: 'Basic Support' },
  { value: 'premium', label: 'Premium Support' },
  { value: 'platinum', label: 'Platinum Support' }
];